import React from 'react';
import { FiCheck, FiExternalLink } from "react-icons/fi";

function FluorescenceGoodToKnow(props) {
    return (
        <div className="rn-about-area ptb--120 bg_color--3">
            <div className="container">
                <div className="row row--35">
                    <div className="col-lg-12">
                        <div className="content-width-limited">
                            <div className="section-title">
                                <h2 className="title">Good to know</h2>
                            </div>
                            <div className="mt--30">
                                <p className="description"><strong>The number of places is limited – advance booking is required for the dates listed on the website <a href="https://ecofungi.si/paketi-dozivetja/" target="_blank" rel="noopener noreferrer" style={{color: 'var(--color-primary)', textDecoration: 'underline'}}>https://ecofungi.si/paketi-dozivetja/ <FiExternalLink style={{display: 'inline', verticalAlign: 'middle', marginLeft: '3px'}} /></a>.</strong></p>

                                <h4 className="mt--40 mb--20">Export tunnel</h4>
                                <ul className="list-style--1">
                                    <li>
                                        <FiCheck />
                                        The tour is suitable for everyone, including people with reduced mobility, as the tunnel is not sloped.
                                    </li>
                                    <li>
                                        <FiCheck />
                                        The tour lasts up to one hour.
                                    </li>
                                    <li>
                                        <FiCheck />
                                        Visitors receive protective equipment – goggles and a helmet.
                                    </li>
                                </ul>

                                <h4 className="mt--40 mb--20">Main tunnel</h4>
                                <ul className="list-style--1">
                                    <li>
                                        <FiCheck />
                                        The tour is open to people aged 10 to 70, or people with good mobility and physical fitness.
                                    </li>
                                    <li>
                                        <FiCheck />
                                        The tour lasts up to two hours.
                                    </li>
                                    <li>
                                        <FiCheck />
                                        Visitors receive protective equipment – goggles, helmet, overalls, boots.
                                    </li>
                                </ul>

                                <h4 className="mt--40 mb--20">General</h4>
                                <ul className="list-style--1">
                                    <li>
                                        <FiCheck />
                                        The minimum group size for a tour is 4 people.
                                    </li>
                                    <li>
                                        <FiCheck />
                                        We recommend comfortable footwear and clothing.
                                    </li>
                                    <li>
                                        <FiCheck />
                                        The temperature in the tunnel is a constant 10 °C and the humidity is 100%.
                                    </li>
                                </ul>
                            </div>

                            <div className="mt--40">
                                <a href="https://ecofungi.si/paketi-dozivetja/" target="_blank" rel="noopener noreferrer" className="btn-default size-md">Book a tour</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default FluorescenceGoodToKnow;
